import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const InfoIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Icons">
        <path
          id="Subtract"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM13.5 8.25C13.5 9.07843 12.8284 9.75 12 9.75C11.1716 9.75 10.5 9.07843 10.5 8.25C10.5 7.42157 11.1716 6.75 12 6.75C12.8284 6.75 13.5 7.42157 13.5 8.25ZM13 10.75V15.25H14V17.25H10V15.25H11V12.75H10V10.75H13Z"
          fill={fillColor || '#CECFD3'}
        />
      </g>
    </svg>
  );
};

export { InfoIcon };
